<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<ng-container appLifecycleTracker trackerName="your-products">
    <div *ngIf="subscriptionDataLoaded">
        <span class="subscription-data-loaded"></span>
    </div>
    <h1 class="centered-banner" *ngIf="!(isCustomerSelected$ | async); else customerSelected">
        {{'products.select-a-customer' | translate}}
    </h1>
    <ng-template #customerSelected>
        <ng-container *ngIf="subscriptions$ | async as subscriptions">
            <h1 class="centered-banner" *ngIf="subscriptions.length === 0">
                {{'products.no-products' | translate}}
            </h1>
            <ng-container *ngFor="let subscription of subscriptions">
                <ng-container [ngSwitch]="subscription.stripe_product.stripe_product_id">
                    <app-bitlocker-sub *ngSwitchCase="BITLOCKER_PRODUCT_PLAN_ID" [subscription]="subscription" title="BitLocker"></app-bitlocker-sub>
                    <app-hardware-sub *ngSwitchCase="HARDWARE_PRODUCT_PLAN_ID" [subscription]="subscription" title="Hardware"></app-hardware-sub>
                    <app-hardware-sub *ngSwitchCase="HARDWARE2_PRODUCT_PLAN_ID" [subscription]="subscription" title="Hardware RAID"></app-hardware-sub>
                    <app-agent-sub *ngSwitchCase="AGENT_PRODUCT_PLAN_ID" [subscription]="subscription" title="Cigent Agent"></app-agent-sub>
                    <app-fde-sub *ngSwitchCase="FDE_PRODUCT_PLAN_ID" [subscription]="subscription" title="Full Drive Encryption"></app-fde-sub>
                    <app-data-defense-sub *ngSwitchDefault [subscription]="subscription" title="Data Defense"></app-data-defense-sub>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-template>
</ng-container>

